import React from "react";
import * as dmsService from "../../../services/dmsService";
import { fmtMoney } from "../../Fin/gl/glContext";
import { DataTable, hint } from "../../Fin/gl/glUi";
import { LoadState, PageHeader, SecondaryButton, cardStyle, pageStyle, useLoad } from "../../../components/ui";

// After-sales Dashboard: open repair orders, this month's workshop and parts sales, technician
// efficiency, warranty claims and parts back orders.
const label = (s) => String(s || "").charAt(0) + String(s || "").slice(1).toLowerCase().replace(/_/g, " ");

function Tile({ title, value, sub }) {
  return (
    <div style={{ ...cardStyle, padding: 16 }}>
      <div style={hint}>{title}</div>
      <div style={{ fontSize: 22, fontWeight: 700 }}>{value}</div>
      {sub ? <div style={hint}>{sub}</div> : null}
    </div>
  );
}

export default function AftersalesDashboard() {
  const { data, loading, error, reload } = useLoad(() => dmsService.getAftersalesDashboard(), []);
  const d = data;
  return (
    <div style={pageStyle}>
      <PageHeader title="After-sales Dashboard" subtitle="Workshop, parts and warranty this month" actions={<SecondaryButton onClick={reload}>Refresh</SecondaryButton>} />
      <LoadState loading={loading} error={error} onRetry={reload}>
        {d ? (
          <>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 12, marginBottom: 16 }}>
              <Tile title="Open repair orders" value={d.open_repair_orders.total} />
              <Tile title="Repair orders invoiced" value={d.month.ros_invoiced} sub={`${fmtMoney(d.month.labour_parts_revenue)} incl. VAT`} />
              <Tile title="Parts orders booked" value={d.month.parts_orders} sub={fmtMoney(d.month.parts_order_value)} />
              <Tile title="Workshop efficiency" value={d.workshop_efficiency_pct === null ? "—" : `${d.workshop_efficiency_pct}%`} sub="Hours sold / hours clocked on finished jobs" />
              <Tile title="Warranty claims open" value={d.warranty.open_claims} sub={`${fmtMoney(d.warranty.claimed)} claimed`} />
              <Tile title="Parts back orders" value={d.parts_back_orders} />
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: 16 }}>
              <div>
                <h6>Repair orders by stage</h6>
                <DataTable rows={d.open_repair_orders.by_status} rowKey={(r) => r.status} minWidth={300} columns={[{ label: "Stage", render: (r) => label(r.status) }, { label: "Orders", num: true, render: (r) => r.n }]} />
              </div>
              <div>
                <h6>Warranty claims</h6>
                <DataTable rows={d.warranty.by_status} rowKey={(r) => r.status} minWidth={300} columns={[{ label: "Status", render: (r) => label(r.status) }, { label: "Claims", num: true, render: (r) => r.n }, { label: "Claimed", num: true, render: (r) => fmtMoney(r.claimed) }]} />
              </div>
            </div>
          </>
        ) : null}
      </LoadState>
    </div>
  );
}
